<template>
    <div class="language-switcher-wrapper">
        <LanguageSwitcher />
    </div>

    <v-container fluid class="fill-height pa-0">
        <v-row no-gutters class="fill-height">
            <!-- Left side: welcome panel -->
            <v-col cols="12" md="6" class="welcome-panel d-flex flex-column justify-center align-center">
                <div class="text-center px-10">
                    <h1 class="display-2 font-weight-bold mb-6">{{ $t('welcometitle') }}</h1>
                    <p class="text-subtitle-1">
                        {{ $t('welcomemessage') }}<br />
                    </p>
                    <img src="../assets/data_login.png" width="300" cover style="border-radius: 3px;" />
                </div>
            </v-col>

            <!-- Right side: login form -->
            <v-col cols="12" md="6" class="d-flex justify-center align-center" style="background: white;">
                <v-card max-width="400" class="pa-8 no-shadow no-border" style="width: 100%; max-width: 420px;" flat>
                    <v-card-title class="text-h4 justify-center mb-0">
                        <h3 class="mb-4" style="color: #40C1AC; font-weight: bold;">{{ $t('login') }}</h3>
                        <img src="../assets/logo_light2.png" alt="Logo" width="200" class="logo mb-0" />
                    </v-card-title>

                    <v-card-text class="pt-0 mt-0">
                        <v-form @submit.prevent="login">
                            <v-text-field :label="$t('username')" type="text" v-model="username" :error="!!errorMessage"
                                required prepend-inner-icon="mdi-account" variant="outlined" density="comfortable" />

                            <v-text-field :label="$t('password')" :type="showPassword ? 'text' : 'password'"
                                v-model="password" :error="!!errorMessage" required prepend-inner-icon="mdi-lock"
                                variant="outlined" density="comfortable">
                                <template #append-inner>
                                    <v-icon class="cursor-pointer" @click="toggleShowPassword"
                                        :title="showPassword ? 'Hide password' : 'Show password'">
                                        {{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                </template>
                            </v-text-field>

                            <!-- Error message shown here -->
                            <div v-if="errorMessage" class="text-error text-body-2 mb-4 text-center">
                                {{ errorMessage }}
                            </div>

                            <v-btn class="mt-2 text-white" color="primary" dark block height="50"
                                style="font-size: 1.2rem;" type="submit">
                                {{ $t('loginbtn') }}
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const router = useRouter()

const username = ref('')
const password = ref('')

const showPassword = ref(false)
const errorMessage = ref('')
const passwordError = ref(false)

function toggleShowPassword() {
    showPassword.value = !showPassword.value
}

const { t } = useI18n()

const API_HOST = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080';

async function login() {
    errorMessage.value = ''
    passwordError.value = false

    if (!username.value || !password.value) {
        errorMessage.value = t('error.fillAllFields')
        return
    }
    
    try {
        const url = API_HOST.trim().replace(/\/$/, '') + '/api/auth/login'
        const response = await axios.post(url, {
            username: username.value,
            password: password.value,
        })

        const token = response.data.token
        const returnedUsername = response.data.user.username || username.value
        console.log(response.data.user.role)
        if (token) {
            localStorage.setItem('authToken', token)
            localStorage.setItem('authUsername', returnedUsername)
            localStorage.setItem('userRole', response.data.user.role || 'user')
            router.push({ name: 'Dashboard' })
        }
    } catch (err) {
        errorMessage.value = t('error.invalidCredentials')
        passwordError.value = true
        console.error(err)
    }
}
</script>

<style scoped>
.fill-height {
    height: 100vh;
}

.welcome-panel {
    background-color: #40c1ac;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: white;
}

.bg-primary {
    color: white !important;
}

.v-btn--block {
    display: flex;
    flex: 1 0 auto;
    min-width: 60%;
    margin-left: 20%;
    margin-right: 20%;
}

.fade-slide-enter-active {
    transition: all 0.6s ease;
}

.fade-slide-leave-active {
    transition: all 0.3s ease;
    opacity: 0;
    transform: translateY(20px);
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateY(20px);
}

.fade-slide-enter-to {
    opacity: 1;
    transform: translateY(0);
}

.language-switcher-wrapper {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;
}

.cursor-pointer {
    cursor: pointer;
}

@media (max-width: 959px) {
    .welcome-panel img {
        display: none !important;
    }

    .language-switcher-wrapper {
        left: 50%;
        transform: translateX(-50%);
        right: auto;
    }
}
</style>
